import { render, staticRenderFns } from "./GroupSubscriptionsView.vue?vue&type=template&id=50a1c4c5"
import script from "./GroupSubscriptionsView.vue?vue&type=script&lang=js"
export * from "./GroupSubscriptionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports